import React from "react";
import Box from "@mui/material/Box";
import LinearProgress from "@mui/material/LinearProgress";
import Typography from "@mui/material/Typography";
export const ProgressBar = ({ value, color = "#3192D0", label, barBg = "#3192D03D", children, }) => {
    return (React.createElement(Box, { sx: { display: "flex", alignItems: "center", width: "100%" } },
        React.createElement(Box, { sx: { width: "100%", mr: 1 } },
            React.createElement(LinearProgress, { variant: "determinate", value: value, sx: {
                    height: 4,
                    borderRadius: 4,
                    backgroundColor: barBg,
                    "& .MuiLinearProgress-bar": {
                        backgroundColor: color,
                        borderRadius: 4,
                    },
                } })),
        React.createElement(Box, { sx: {
                minWidth: 32,
                fontSize: 12,
                color: "text.secondary",
                display: "flex",
                alignItems: "center",
            } },
            label ? React.createElement(Typography, { variant: "body2" }, label) : `${value === 0 ? "0" : value.toFixed(1)}%`,
            children)));
};
